import store from 'store';

function _initSpinInstance() {
  const html = `
    <div class="overlay">
      <i class="fa fa-refresh fa-spin"></i>
    </div>
  `;
  return $(html);
}

const moduleExports = {
  /*
   * loading相关 开始
   */
  LoadingInstance: null,
  /* 在屏幕中央显示loading */
  showLoading(domContainer) {
    this.LoadingInstance = this.LoadingInstance || _initSpinInstance();
    domContainer = domContainer || $('#main-box');
    domContainer.append(this.LoadingInstance);
  },
  /* 消除屏幕中央的loading */
  hideLoading() {
    if (!this.LoadingInstance) return;

    this.LoadingInstance.remove();
  },
  /*
   * loading相关 结束
   */

  /**
   * URL相关 开始
   */
  /* 在新窗口打开指定的URL */
  openNewWindow(redirectUrl) {
    $('body').append(`<a href="${redirectUrl}" target="_blank" id="hidden-link" style="visibility: hidden;">在新窗口打开指定URL</a>`);
    document.getElementById('hidden-link').click();
  },
  /* URL相关 结束 */

  /* 从一个对象中取出指定的字段形成一个新对象 */
  fetchObjFields(fieldsArr, obj) {
    const resultObj = {};
    for (let i = 0; i < fieldsArr.length; i++) {
      const _key = fieldsArr[i];
      resultObj[_key] = obj[_key];
    }
    return resultObj;
  },

  /* 格式化处理浮点型（带小数位） */
  formatFloat(num, pos) {
    pos = pos || 2;
    return Math.round(num * Math.pow(10, pos)) / Math.pow(10, pos);
  },

  /* 获取URL上的get参数 */
  getRequestParams() {
    const url = window.location.search; // 获取url中"?"符后的字串
    const theRequest = {};
    if (url.indexOf('?') !== -1) {
      const str = url.substr(1);
      const strs = str.split('&');
      for (let i = 0; i < strs.length; i++) {
        theRequest[strs[i].split('=')[0]] = unescape(strs[i].split('=')[1]);
      }
    }
    return theRequest;
  },

  validate: {
    all() {
      this.$v.form.$touch();
      return this.$v.form.$invalid;
    },
    target(target) {
      target.$touch();
      return target.$invalid;
    },
  },

  tooltip: {
    init() {
      $('[data-toggle="tooltip"]').tooltip({
        container: 'body',
        placement: 'top',
      });
    },

    hide($dom) {
      $dom.tooltip('hide');
    },
  },

  locStorage: {
    set: function set(key, val) {
      store.set(key, val);
      return this;
    },

    get: function get(key) {
      return store.get(key);
    },

    remove(key) {
      store.remove(key);
      return this;
    },

    clear() {
      store.clearAll();
      return this;
    },
  },
};

export default moduleExports;

export function randomInt(min = 0, max = 100000) {
  return Math.round(Math.random() * (max - min) + min);
}

export function nl2br(str, isXhtml) {
  //  discuss at: http://locutus.io/php/nl2br/
  // original by: Kevin van Zonneveld (http://kvz.io)
  // improved by: Philip Peterson
  // improved by: Onno Marsman (https://twitter.com/onnomarsman)
  // improved by: Atli Þór
  // improved by: Brett Zamir (http://brett-zamir.me)
  // improved by: Maximusya
  // bugfixed by: Onno Marsman (https://twitter.com/onnomarsman)
  // bugfixed by: Kevin van Zonneveld (http://kvz.io)
  // bugfixed by: Reynier de la Rosa (http://scriptinside.blogspot.com.es/)
  //    input by: Brett Zamir (http://brett-zamir.me)
  //   example 1: nl2br('Kevin\nvan\nZonneveld')
  //   returns 1: 'Kevin<br />\nvan<br />\nZonneveld'
  //   example 2: nl2br("\nOne\nTwo\n\nThree\n", false)
  //   returns 2: '<br>\nOne<br>\nTwo<br>\n<br>\nThree<br>\n'
  //   example 3: nl2br("\nOne\nTwo\n\nThree\n", true)
  //   returns 3: '<br />\nOne<br />\nTwo<br />\n<br />\nThree<br />\n'
  //   example 4: nl2br(null)
  //   returns 4: ''
  // Some latest browsers when str is null return and unexpected null value
  if (typeof str === 'undefined' || str === null) {
    return '';
  }
  // Adjust comment to avoid issue on locutus.io display
  var breakTag = (isXhtml || typeof isXhtml === 'undefined') ? '<br ' + '/>' : '<br>';
  return (str + '')
    .replace(/(\r\n|\n\r|\r|\n)/g, breakTag + '$1');
}

export function nl2p(str) {
  // return '<p>'.preg_replace(/([\n]{1,})/, '</p>\n<p>', trim(str)) + '</p>';
  return '<p>' + trim(str).replace(/([\n]{1,})/gi, '</p>\n<p>') + '</p>';
}

export function trim(str, charlist) {
  //  discuss at: http://locutus.io/php/trim/
  // original by: Kevin van Zonneveld (http://kvz.io)
  // improved by: mdsjack (http://www.mdsjack.bo.it)
  // improved by: Alexander Ermolaev (http://snippets.dzone.com/user/AlexanderErmolaev)
  // improved by: Kevin van Zonneveld (http://kvz.io)
  // improved by: Steven Levithan (http://blog.stevenlevithan.com)
  // improved by: Jack
  //    input by: Erkekjetter
  //    input by: DxGx
  // bugfixed by: Onno Marsman (https://twitter.com/onnomarsman)
  //   example 1: trim('    Kevin van Zonneveld    ')
  //   returns 1: 'Kevin van Zonneveld'
  //   example 2: trim('Hello World', 'Hdle')
  //   returns 2: 'o Wor'
  //   example 3: trim(16, 1)
  //   returns 3: '6'
  var whitespace = [
    ' ',
    '\n',
    '\r',
    '\t',
    '\f',
    '\x0b',
    '\xa0',
    '\u2000',
    '\u2001',
    '\u2002',
    '\u2003',
    '\u2004',
    '\u2005',
    '\u2006',
    '\u2007',
    '\u2008',
    '\u2009',
    '\u200a',
    '\u200b',
    '\u2028',
    '\u2029',
    '\u3000',
  ].join('');
  var l = 0;
  var i = 0;
  str += '';
  if (charlist) {
    whitespace = (charlist + '').replace(/([[\]().?/*{}+$^:])/g, '$1');
  }
  l = str.length;
  for (i = 0; i < l; i++) {
    if (whitespace.indexOf(str.charAt(i)) === -1) {
      str = str.substring(i);
      break;
    }
  }
  l = str.length;
  for (i = l - 1; i >= 0; i--) {
    if (whitespace.indexOf(str.charAt(i)) === -1) {
      str = str.substring(0, i + 1);
      break;
    }
  }
  return whitespace.indexOf(str.charAt(0)) === -1 ? str : '';
}

export function type(obj) {
  return Object.prototype.toString.call(obj).slice(8, -1);
}

export const _ = {
  debounce: function(fn, wait, immediate) {
    var timeout,
      args,
      context,
      timestamp,
      result;

    var later = function() {
      var last = _.now() - timestamp;

      if (last < wait && last >= 0) {
        timeout = setTimeout(later, wait - last);
      } else {
        timeout = null;
        if (!immediate) {
          result = fn.apply(context, args);

          if (!timeout) {
            context = args = null;
          }
        }
      }
    };

    return function() {
      context = this;
      args = arguments;
      timestamp = _.now();
      var callNow = immediate && !timeout;

      if (!timeout) {
        timeout = setTimeout(later, wait);
      }

      if (callNow) {
        result = fn.apply(context, args);
        context = args = null;
      }

      return result;
    };
  },
  now: Date.now || function() {
    return new Date().getTime();
  },
};



// WEBPACK FOOTER //
// ./src/libs/index.js